import createImageUrlBuilder from '@sanity/image-url';

import { dataset, projectId } from '@dashboard/services/env';

const imageBuilder = createImageUrlBuilder({
  projectId: projectId || '',
  dataset: dataset || '',
});

export const urlForImage = source => {
  return imageBuilder?.image(source).auto('format').fit('max').url();
};

export const urlForImageWithSize = (source, width, height) => {
  return imageBuilder?.image(source).auto('format').fit('max').width(width).height(height).url();
};
